import { AndFilter, BaseFilter, Filter, HasFilter, IFilter, OrFilter, SubsetFilter } from "./filter";

export class FilterBuilder {

    private filters:IFilter[] = [];

    public static loadSavedFilters(filters:any, savedFilters:any) {
        if (savedFilters == null) return;
        for (let key in savedFilters) {
            let savedFilter = savedFilters[key];
            if (filters.hasOwnProperty(key)) {
                let filter = filters[key];
                if (filter instanceof Filter) {
                    filter.value = savedFilter.value;
                    //console.log("FilterBuilder", "loadSavedFilters", key, filter.value);
                }else if (filter instanceof HasFilter) {
                    (filter.filter as Filter).value = savedFilter.filter.value;
                    //console.log("FilterBuilder", "loadSavedFilters", key, (filter.filter as Filter).value);
                }else if (filter instanceof OrFilter) {
                    //console.log("FilterBuilder", "loadSavedFilters->OrFilter", key);
                    this.loadSavedFilters(filter.filters, savedFilter.filters);
                }
            }
        }
    }

    public static fromObject(obj: any): FilterBuilder {
        let _instance = new FilterBuilder();
        _instance.filters = [];
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                let filter:any = obj[key];
                if(filter instanceof BaseFilter) {
                    //if(filter.value!=null || filter.allowNull || filter instanceof AndFilter)
                    _instance.filters.push(filter as IFilter);
                }
            }
        }
        return _instance;
    }

    public build(): string[] {
        //deben unirse todos los filtros para el mismo tipo en un solo parametros como and(,)
        let paramFilters:string[] = [];

        //agrupamos los filtro por relacion
        let filtersByRelationship:any = {};
        this.filters.forEach((filter:IFilter) => {
            let subset = '';
            if(filter instanceof SubsetFilter) subset = filter.getSubset();
            if(filtersByRelationship[subset] == null) filtersByRelationship[subset] = [];
            filtersByRelationship[subset].push(filter);
        });
        
        //genramos filtros por cada relacion
        for (let key in filtersByRelationship) {
            let filters = filtersByRelationship[key];
            let filterStrings:string[] = [];
            filters.forEach((filter:IFilter) => {
                //if(filter.value!=null || filter.isAllowNull() || filter instanceof AndFilter) {
                    let filterQueryString = filter.toQueryString();
                    if(filterQueryString!='') filterStrings.push(filterQueryString);
                //}else{
                //    console.debug("FilterBuilder", "Filter value is null or allowNull is false", filter);
                //}
            });
            let filterRelation = '';
            //si el filtro es para la raiz no se añade la relacion
            if(key != '') filterRelation = "[" + key + "]";
            if(filterStrings.length == 1) {
                paramFilters.push("filter" + filterRelation + "=" + encodeURIComponent(filterStrings.join(',')));
            }else if(filterStrings.length > 1) {
                paramFilters.push("filter" + filterRelation + "=" + encodeURIComponent('and(' + filterStrings.join(',') + ')'));
            }
        }

        return paramFilters;
        //return this.filters;
    }

}